/**
 * 易贝能源
 * @type {{BASE_SPLIT: string, BASE_API: string, dev: {BASE_URL: string}, prod: {BASE_URL: string}}}
 */
const txEpeis = {
  BASE_SPLIT: '/mp/',
  BASE_API: '/mpapi',
  'dev': {
    BASE_URL: '"https://127.0.0.1:9091/mpapi"',
  },
  'prod': {
    BASE_URL: '"https://wx.gsjhfz.com/mpapi/"',
    /*BASE_URL: '"https://132.232.195.129/mpapi/"',*/
  }
};

/**
 * 嘉恒发展
 * @type {{BASE_SPLIT: string, BASE_API: string, dev: {BASE_URL: string}, prod: {BASE_URL: string}}}
 */
const jgEpeis = {
  BASE_SPLIT: '/oa/',
  BASE_API: '/oa-api',
  'dev': {
    BASE_URL: '"https://127.0.0.1:9091/oa-api"',
  },
  'prod': {
    BASE_URL: '"https://wx.gsjhfz.com/oa-api"',
    // BASE_URL: '"https://10.1.213.78:1889/oa-api"',
    BASE_URL_PC_API: '"https://wx.gsjhfz.com/api"',
    BASE_URL_OPENAPI: '"https://wx.gsjhfz.com/3rdapi"',
  }
};

module.exports = jgEpeis;



//////////////////
// WEBPACK FOOTER
// ./config/app.env.js
// module id = OEQ9
// module chunks = 84